const RUNS_BASE = '/agents/runs';

const segment = (value: string) => encodeURIComponent(value);

export const agentHarnessRunPath = (agentRunId: string) =>
  `${RUNS_BASE}/${segment(agentRunId)}`;

export const agentHarnessRunTurnsPath = (agentRunId: string) =>
  `${agentHarnessRunPath(agentRunId)}/turns`;

export const agentHarnessRunCancelPath = (agentRunId: string) =>
  `${agentHarnessRunPath(agentRunId)}:cancel`;

export const agentHarnessRunApprovalModePath = (agentRunId: string) =>
  `${agentHarnessRunPath(agentRunId)}/approval-mode`;

export const agentHarnessRunApprovalsPath = (agentRunId: string) =>
  `${agentHarnessRunPath(agentRunId)}/approvals`;

export const agentHarnessRunApprovalResolvePath = (
  agentRunId: string,
  approvalId: string
) => `${agentHarnessRunApprovalsPath(agentRunId)}/${segment(approvalId)}:resolve`;

export const agentHarnessAttachmentContentPath = (
  agentRunId: string,
  attachmentId: string
) => `${agentHarnessRunPath(agentRunId)}/attachments/${segment(attachmentId)}/content`;

export const agentHarnessAttachmentDownloadUrlPath = (
  agentRunId: string,
  attachmentId: string
) =>
  `${agentHarnessRunPath(agentRunId)}/attachments/${segment(attachmentId)}/download-url`;

export const agentHarnessRunStreamPath = (agentRunId: string) =>
  `${agentHarnessRunPath(agentRunId)}/stream`;

export const agentHarnessRunEventsPath = (agentRunId: string) =>
  `${agentHarnessRunPath(agentRunId)}/events`;
